import React from 'react'
import PageLayout from '../../components/layout/PageLayout'
import {Groups} from '../../apis/analysis/getData'
import ServerAnalysisContainer from './DataAnalysisContainer'

interface IProps {
    className?: string
}

const ServerAnalysisPage: React.FC<IProps> = ({className}) => {
    return (
        <PageLayout title={'analysis'} className={'flex w-[4800px]'}>
            {Object.keys(Groups).map(k => {
                let v = Groups[k]
                return <ServerAnalysisContainer Igroup={k} condition={v} />
            })}
        </PageLayout>
    )
}

export default ServerAnalysisPage
